// extracted by mini-css-extract-plugin
module.exports = {"selected-facet-terms":"SelectedFacetTerms_selected-facet-terms__IpWhc","selected-facet-terms__term":"SelectedFacetTerms_selected-facet-terms__term__37PcH"};